module.exports = "/_next/static/images/card_gradient-366e6e4eaf76cdc4d48bd1138a5f566c.png";